import { render, staticRenderFns } from "./GuestbookList.vue?vue&type=template&id=2660d3be&scoped=true"
import script from "./GuestbookList.ts?vue&type=script&lang=ts&external"
export * from "./GuestbookList.ts?vue&type=script&lang=ts&external"
import style0 from "./GuestbookList.scss?vue&type=style&index=0&id=2660d3be&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2660d3be",
  null
  
)

export default component.exports